import { memo } from 'react';
import styled from 'styled-components';

const StyledBadge = styled.div<StyledBadgeProps>`
    display: inline-block;
    background: ${({ $backgroundColor }) => $backgroundColor};
    color: ${({ $textColor }) => $textColor};
    border-radius: 1.2rem;
    min-width: 1.4rem;
    padding: 1px 2px;
    text-align: center;
    font-size: 1.2rem;
`;

type StyledBadgeProps = {
    $backgroundColor: string;
    $textColor: string;
};

export type BadgeProps = Readonly<{
    count: number;
    textColor: string;
    backgroundColor: string;
    className?: string;
}>;

export type BadgeConfig = Readonly<{
    count: number;
    textColor: string;
    backgroundColor: string;
}>;

function Badge({ backgroundColor, textColor, count, className }: BadgeProps) {
    return (
        <StyledBadge
            className={className}
            $backgroundColor={backgroundColor}
            $textColor={textColor}
        >
            <div>{count}</div>
        </StyledBadge>
    );
}

const memoBadge = memo(Badge);
export { memoBadge as Badge };
